import env from 'enviro';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { stringifyQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
const createSignupQuery = signupIntent => {
  if (!signupIntent) return {};
  return {
    [SignupQueryKeys.Intent]: signupIntent
  };
};
const cleanUpQueryParams = queryParams => {
  const queryParamsMap = {
    currency: queryParams.currencyCode,
    'hubs_signup-url': queryParams.hubsSignupUrl,
    'hubs_signup-cta': queryParams.hubsSignupCta,
    dtbId: queryParams.dtbId,
    dtb_source: queryParams.dtbSource,
    hsSeats: queryParams.isUngatedForSeats
  };
  Object.keys(queryParamsMap).forEach(key => {
    if (queryParamsMap[key] === undefined || queryParamsMap[key] === null) {
      delete queryParamsMap[key];
    } else if (typeof queryParamsMap[key] !== 'string') {
      queryParamsMap[key] = `${queryParamsMap[key]}`;
    }
  });
  return queryParamsMap;
};
// Not to be confused  with hubs signup url, this is the actual URL
// of the signup app we're sending the user to
export const generateSignupUrlWithQueryParams = ({
  signupType,
  signupIntent,
  queryParams
}) => {
  const queryParamsMap = cleanUpQueryParams(queryParams);
  const stringifiedQueryParams = stringifyQueryParams(queryParamsMap);
  const signupQuery = createSignupQuery(signupIntent);
  const baseUrl = new SignupUrlGenerator(signupType, {
    query: signupQuery,
    env: env.isQa() || getIsQAProxy() ? 'qa' : 'prod'
  }).getUrl();
  const initialQueryParamPunctuation = signupIntent ? '&' : '?';
  return `${baseUrl}${initialQueryParamPunctuation}${stringifiedQueryParams}`;
};